import { get } from './api'
import { ENDPOINTS } from './endpoints'

import type { CurrentUserResponse } from './types/user'

export const getUser = async () =>
  get<CurrentUserResponse>(`${process.env.API_BASE_URL}${ENDPOINTS.USER()}`)
